import React, { useEffect, useState } from 'react'
import TableHeader from '../Shared/TableHeader'
import { LeadFormActions } from '../../Services/_actions';
import CommonTable from '../Shared/Tables';
import ReactPagination from '../Shared/Pagination';
import { renderToolTip } from '../../utils/helper';
import SearchBox from '../Shared/SearchBox';
import { Button, Col, Row } from 'react-bootstrap';
import FilterOffcanvas from '../Shared/FilterOffcanvas';
import SelectDropdown from '../Shared/SelectDropdown';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { BackButton } from '../Shared/BackButton';
import { useRecoilState } from 'recoil';
import { agentDatewiseSelectedDispositionAtom } from '../../Services/_states';
import DateRangeFilter from '../Shared/DateRangeFilter/DateRangeFilter.tsx';
import FilterListIcon from '@mui/icons-material/FilterList';

const AgentDatewiseSummary = () => {
    const { agentNumber, agentName,dispositionStatus } = useParams();
    const navigate = useNavigate();
    const leadFormActions = LeadFormActions();
    const [agentSummaryData, setAgentSummaryData] = useState({});
    const [filterObj, setFilterObj] = useState({ agentNumber: agentNumber, page: 0, limit: 10, startDate: null, endDate: null, disposition:dispositionStatus,dispositionStatusList:'' });
    const [isLoading, setIsLoading] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [selectedDispositionArr, setSelectedDispositionArr] = useRecoilState(agentDatewiseSelectedDispositionAtom);
    const [isColumnsReset, setIsColumnsReset] = useState(false);

    const initialColumns = [
        {
            dataField: 'index',
            text: 'S.No.',
            formatter: (cell, row, rowIndex) => rowIndex + 1,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width:'50px' }
        },
        {
            dataField: 'date',
            text: 'Date',
            headerAlign: 'center',
            align: 'center',
        },
        {
            dataField: 'total_calls',
            text: 'Total calls',
            headerAlign: 'center',
            align: 'center',
            formatter: (cell, row) => {
                return <Link to={`/r/caller-dashboard/agent-users/${agentName}/${agentNumber}/${row?.date}/total_calls`}>{row?.total_calls}</Link>
            }
        },
    ]
    const [columns, setColumns] = useState(initialColumns);

    const addColumns = () => {
        if (selectedDispositionArr?.length) {
            const col = [
                ...initialColumns,
                ...selectedDispositionArr?.map(item => ({
                    // dataField: item.value.toLowerCase().replace(/\s+/g, '_'),
                    dataField: item.value,
                    text: item.label,
                    headerAlign: 'center',
                    align: 'center',
                    formatter: (cell, row) => {
                        if (row?.dispositions?.[item.value] && row?.dispositions?.[item.value] > 0)
                            return <Link to={`/r/caller-dashboard/agent-users/${agentName || 'Agent'}/${agentNumber || ''}/${row?.date}/${item.value || 'total_calls'}`}>{row?.dispositions?.[item.value] || 0}</Link>
                        else
                            return <span>0</span>
                    }
                }))
            ]
            setColumns(col);
        } else
            setColumns([...initialColumns]);
    };


    const clearFilters = () => {
        let obj = {
            agentNumber: agentNumber,page: 0, limit: 10, start_date: null, end_date: null, disposition: dispositionStatus,dispositionStatusList:''
        }
        setSelectedDispositionArr([]);
        setFilterObj(obj);
        getAgentDatewiseSummaryData(obj);
    }

    const getAgentDatewiseSummaryData = async (obj) => {
        setIsLoading(true);
        setIsColumnsReset(true);
        if (selectedDispositionArr) {
            const str = selectedDispositionArr?.map(item => item?.value).join(",");
            obj = { ...obj, dispositionStatusList: str };
        };
        let res = await leadFormActions.getAgentDatewiseSummaryData(obj);
        if (res?.status === 200)
            setAgentSummaryData(res?.data || {});
        setIsLoading(false);
        // addColumns();
    }
    useEffect(() => {
        if (isColumnsReset) {
            addColumns();
            setIsColumnsReset(false);
        }
    }, [isColumnsReset]);


    const onPageChange = (e) => {
        getAgentDatewiseSummaryData({ ...filterObj, page: e?.selected });
        setFilterObj({ ...filterObj, page: e?.selected });
    }

    const onSearch = (e) => {
        setFilterObj({ ...filterObj, search: e });
        if (e.length > 2 || !e)
            getAgentDatewiseSummaryData({ ...filterObj, search: e, page: 0 });
    }

    const onSelectDisposition = (e) => {
        setSelectedDispositionArr(e);
        // if (e) {
        //     const str = e?.map(item => item?.value).join(",");
        //     setFilterObj({ ...filterObj, dispositionStatusList: str || '' });
        // }
    }


    const handleTableChange = (type, { sortField, sortOrder, data }) => {
        // if (type === 'sort') {
        //     if (sortField !== filters.sort_by || sortOrder !== filters.order) {
        //         setFilterObj({ ...filters, sort_by: sortField, order: sortOrder });
        //         setAgentSummaryData({ ...filters, sort_by: sortField, order: sortOrder });

        //     }
        // }
    }

    const backButton = () => {
        return (
            <BackButton onClick={() => navigate(-1)} />
        );
    };


    useEffect(() => {
        getAgentDatewiseSummaryData(filterObj)
    }, [])

    return (
        <>
            <TableHeader headerValue={`${agentNumber}-${agentName}`} isBackButton={backButton} />
            <div className='d-flex'>
                <div>
                    {renderToolTip(
                        'Filters',
                        <FilterListIcon
                            style={{ fontSize: '20px', margin: '5px', cursor: 'pointer' }}
                            onClick={() => {
                                setShowFilter(true);
                            }}
                        />
                    )}
                </div>
                {/* <div className="pb-2">
                    <SearchBox onSearch={onSearch} placeholder='Search' value={filterObj?.search} />
                </div>{' '} */}
            </div>

            <CommonTable
                id={'date'}
                columnsData={columns}
                rowData={agentSummaryData?.list || []}
                // defaultSorted={[{ dataField: filterObj?.sort_by, order: filterObj?.order }]}
                handleTableChange={handleTableChange}
                remote={{ sort: true }}
                isLoading={isLoading}
            />
            <ReactPagination
                pageNo={filterObj?.page}
                pageSize={filterObj?.limit}
                totalItems={agentSummaryData?.count}
                onPageChange={onPageChange}
            />

            <FilterOffcanvas
                show={showFilter}
                onHide={() => setShowFilter(false)}
                bodyData={
                    <>
                        <div className="mb-3">
                            <SelectDropdown
                                optionsData={leadFormActions.despositionStatusArr}
                                selectedValue={selectedDispositionArr}
                                placeholder="Select Disposition"
                                handleSelect={(e) => { onSelectDisposition(e) }}
                                isClearable={true}
                                isMulti={true}
                            />
                        </div>
                        <div className='mb-3'>
                            <DateRangeFilter
                                isClearable={true}
                                handleDateChange={(dates) => {
                                    setFilterObj({ ...filterObj, startDate: dates[0], endDate: dates[1] });
                                }}
                                onApply={(range) => {
                                    setFilterObj({ ...filterObj, startDate: range.startDate, endDate: range.endDate });
                                }}
                                startDate={filterObj?.startDate}
                                endDate={filterObj?.endDate}
                            />
                        </div>
                        <Row>
                            <Col>
                                <Button variant="primary" onClick={() => { getAgentDatewiseSummaryData(filterObj), setShowFilter(false) }}>Submit</Button>
                            </Col>
                            <Col>
                                <Button variant="secondary" onClick={() => { clearFilters(), setShowFilter(false) }}>Clear</Button>
                            </Col>
                        </Row>
                    </>
                }
            />
        </>
    )
}

export default AgentDatewiseSummary